import React from 'react';
import { useParams } from 'react-router-dom';
import bitmapBackground from 'assets/images/bitmap-background.png';
import MainLayout from 'components/layout/MainLayout';
import { AppRoutes, ButtonTypes } from 'types';
import Assignment from './components/Assignment';
import AssignmentsCarousel from './components/AssignmentsCarousel';
import { RouteSource } from '@monorepo/shared/src/graph/schema-generated-types-student';

const Assignments: React.FC = () => {
  const { assignmentId } = useParams();

  return (
    <MainLayout
      backgroundImg={bitmapBackground}
      menuProps={{
        primaryLeftButton: { name: ButtonTypes.HOME_BUTTON },
        secondaryLeftButton: assignmentId
          ? {
              name: ButtonTypes.BACK_BUTTON,
              redirectRoute: {
                path: `/${AppRoutes.ASSIGNMENTS}`,
                title: AppRoutes.ASSIGNMENTS as any,
              },
              color: 'inherit',
            }
          : undefined,

        primaryRightButton: { name: ButtonTypes.REWARD_BUTTON },
      }}
      footerProps={{
        primaryLeftButton: {
          name: ButtonTypes.MAT_MAN_BUTTON,
          from: RouteSource.ASSIGNMENTS,
        },
        primaryRightButton: { name: ButtonTypes.ACCESSIBILITY_BUTTON },
      }}
      gutterBottom
    >
      {assignmentId ? <Assignment /> : <AssignmentsCarousel />}
    </MainLayout>
  );
};

export default Assignments;
